import React from 'react';
import { useRecoilState } from 'recoil';
import { askVennPanelOpenAtom } from 'venn-state';
import { cn } from '@/lib/utils';
import { getTextThemeProvider, Icon } from 'venn-ui-kit';
import { Tooltip, TooltipContentWithArrow, TooltipTrigger } from '@/components/ui/tooltip';

const AskVennToggle = () => {
  const [isOpen, setIsOpen] = useRecoilState(askVennPanelOpenAtom);

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          type="button"
          data-testid="qa-ask-venn-toggle"
          onClick={() => setIsOpen((prev) => !prev)}
          className={cn(
            'flex gap-[6px] items-center justify-center h-[64px] w-[64px] border-none cursor-pointer transition-colors outline-none focus:outline-none focus-visible:outline-none',
            isOpen
              ? 'bg-venn-grey-10 text-venn-dark-blue'
              : 'bg-transparent text-white hover:bg-venn-grey-80 hover:text-white',
          )}
          aria-label={getTextThemeProvider().askAiName}
        >
          <Icon type="sparkles" prefix="fas" className="text-[22px]" />
        </button>
      </TooltipTrigger>
      <TooltipContentWithArrow side="bottom">{getTextThemeProvider().askAiName}</TooltipContentWithArrow>
    </Tooltip>
  );
};

export default AskVennToggle;
